module.exports = __webpack_public_path__ + "static/media/dansaSyoukou.688c1b6a.png";